import { getTwoType } from '@/axios/api'

const travleSec = {
  state: {
    travleSec: []
  },
  mutations: {
    SET_TRAVLESEC (state, travleSec) {
      state.travleSec = travleSec
    }
  },
  actions: {
    TRAVLESEC ({ commit }, params) {
      getTwoType(params).then(res => {
        this.state.travleSec = res.data.data
      })
    }
  }
}

export default travleSec



// WEBPACK FOOTER //
// ./src/store/modules/travleSec.js